// noinspection GraphQLUnresolvedReference

import {gql, TypedDocumentNode} from "@apollo/client";
import {CreateArtworkResponse, CreateArtworkVariable, NotifyProductType, Nullable, ReviewFeedbackType} from "./types";
import {CREATE_ARTWORK_PAYLOAD_FRAGMENT, NOTIFY_PRODUCT_FRAGMENT} from "./fragments";

export const MUTATION_CREATE_ARTWORK: TypedDocumentNode<CreateArtworkResponse, CreateArtworkVariable> = gql`
    ${CREATE_ARTWORK_PAYLOAD_FRAGMENT}
    mutation CreateArtworkMutation($filename: String, $storageId: String, $accountId: Int, $notes: String) {
        payload: createArtwork(input: { filename: $filename, storageId: $storageId, accountId: $accountId, notes: $notes }) {
            ...CreateArtworkPayloadFragment
        }
    }
`;

export const MUTATION_CREATE_REVIEW_FEEDBACK: TypedDocumentNode<{
    payload: Nullable<{
        reviewFeedback: Nullable<ReviewFeedbackType>
    }>
}, {
    reviewId: number,
    reason?: string
}> = gql`
    mutation CreateReviewFeedbackMutation($reviewId: Int!, $reason: String) {
        payload: createReviewFeedback(input: { reviewId: $reviewId, reason: $reason }) {
            reviewFeedback {
                id
                reviewId
                ownerId
                reason
                ip
                approved
                approvedBy
                approvedOn
                created
            }
        }
    }
`;

export const MUTATION_CREATE_NOTIFY_PRODUCT: TypedDocumentNode<{
    notifyProduct: NotifyProductType
}, {
    email: string,
    productId: number,
    catalogId: number
}> = gql`
    ${NOTIFY_PRODUCT_FRAGMENT}
    mutation CreateNotifyProductMutation($email: String!, $productId:Int!, $catalogId: Int!) {
        notifyProduct: createNotifyProduct(input: {email: $email, productId: $productId,  catalogId: $catalogId}) {
            ...NotifyProductFragment
        }
    }
`;

export const MUTATION_CREATE_LIST: TypedDocumentNode<{
    payload: Nullable<{
        id: number,
        accountId: number,
        name?: string,
        path: string,
        url: string,
        notes?: string,
        active: boolean
        private: boolean
    }>
}, {
    accountId: number,
    catalogId: number,
    name: string,
    notes?: string
}> = gql`
    mutation CreateListMutation($accountId: Int!, $catalogId: Int!, $name: String!, $notes: String) {
        payload: createList(input: { accountId: $accountId, catalogId: $catalogId, name: $name, notes: $notes }) {
            id
            accountId
            name
            path
            url
            notes
            active
            private
            created
        }
    }
`;

export const MUTATION_CREATE_LIST_ITEM: TypedDocumentNode<{
    id: number,
    listId: number,
    productId: number
} | undefined, {
    listId: number,
    productId: number,
    accountId: number,
    catalogId: number
}> = gql`
    mutation CreateListItemMutation($listId: Int!, $productId: Int!, $accountId: Int!, $catalogId: Int!) {
        payload: createListItem(input: { listId: $listId, productId: $productId, accountId: $accountId, catalogId: $catalogId }) {
            id
            listId
            productId
            created
        }
    }
`;

export const MUTATION_DELETE_LIST_ITEM: TypedDocumentNode<{
    id?: number
}, {
    listId: number,
    productId: number,
    accountId: number
}> = gql`
    mutation DeleteListItemMutation($listId: Int!, $productId: Int!, $accountId: Int!) {
        payload: deleteListItem(input: { listId: $listId, productId: $productId, accountId: $accountId }) {
            id
        }
    }
`;